import { IAoeState } from "../interfaces/aoe-state";

export const aoeInitState: IAoeState = {
    breadcrumbs: [],
    breadcrumbHistory: [],
};
